import { render, staticRenderFns } from "./NotPurchased.vue?vue&type=template&id=5a880ef0&scoped=true"
import script from "./NotPurchased.vue?vue&type=script&lang=js"
export * from "./NotPurchased.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a880ef0",
  null
  
)

export default component.exports